import React, { useEffect, useState } from 'react';
import withRouter from '../../components/Common/withRouter';
import Spinners from '../../components/Common/Spinner';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

//Import Breadcrumb
//import Breadcrumbs from '../../components/Common/Breadcrumb';

import BusinessLocationAppFees from './components/businessLocationAppFee';

//redux
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import VerticalLayout from '../../components/VerticalLayout';
import DefaultAppFee from './components/defaultAppFee';
import DefaultSubscriptionPlan from './components/defulatSubscriptionPlan';
const AppFee = () => {
  //meta title
  document.title = 'App Fee | Seamless Slot  ';

  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { id: 0, text: 'Default App Fee' },
    { id: 1, text: 'Business & Location App Fee' },
    { id: 2, text: 'Subscription Plan' }
  ];

  const ContactsProperties = createSelector(
    (state) => state.contacts,
    (Contacts) => ({
      users: Contacts?.users,
      loading: Contacts?.loading
    })
  );

  const { loading } = useSelector(ContactsProperties);

  const [isLoading, setLoading] = useState(loading);

  useEffect(() => {
    localStorage.setItem('path', '/appfees');
  }, []);

  return (
    <VerticalLayout>
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            {/* <Breadcrumbs title="App Fee" breadcrumbItem="App Fee" /> */}
            <div className="d-flex justify-content-between align-items-center w-100 mb-3">
              {/* Left side */}
              <p style={{ fontSize: '16px', fontWeight: 500, color: '#000', margin: 0 }}>App Fee</p>

              {/* Right side */}
              <div className="d-flex align-items-center gap-3"></div>
            </div>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center gap-3">
                        <p className="text-dark" style={{ fontWeight: '600', fontSize: '15px' }}>
                          App Fee
                        </p>
                      </div>
                      <div className="d-flex align-items-center  gap-3 pointer text-dark">
                        {tabs?.map((item) => {
                          return (
                            <div
                              onClick={() => setSelectedTab(item?.id)}
                              style={{
                                borderBottom: '2px solid',
                                borderColor: item?.id == selectedTab ? '#000' : 'white',
                                color: item?.id == selectedTab ? '#000' : '#495057',
                                fontSize: '13px',
                                fontWeight: '400',
                                cursor: 'pointer'
                              }}
                              key={item?.id}
                              className="pb-2 text-dark"
                            >
                              {item?.text}
                            </div>
                          );
                        })}
                      </div>

                      <div className="mt-4">
                        {selectedTab == 0 && <DefaultAppFee />}
                        {selectedTab == 1 && <BusinessLocationAppFees />}
                        {selectedTab == 2 && <DefaultSubscriptionPlan />}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    </VerticalLayout>
  );
};

export default withRouter(AppFee);
